import React, { useState } from 'react';
import { useRef } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import {
	MdStar,
	MdStarHalf,
	MdStarOutline,
	MdStarBorder,
} from 'react-icons/md';
import UiButton from '../../Ui/Button';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../../init.firebase';
import ReactStars from 'react-rating-stars-component';
import { toast } from 'react-toastify';
import { useAddSingleReviewMutation } from '../../../redux/products/productsApi';
import { Navigate, useNavigate } from 'react-router-dom';

const WriteReview = ({ productId }) => {
	const [showComment, setShowComment] = useState(false);
	const [rating, setRating] = useState(5);
	const navigate = useNavigate();
	const commentRef = useRef();
	const [addSingleReview, { isLoading, isError, isSuccess }] =
		useAddSingleReviewMutation();
	const [user] = useAuthState(auth);

	const handleSubmit = (e) => {
		e.preventDefault();

		const userEmail = user?.email;
		const comment = commentRef.current.value;
		const data = {
			description: comment,
			product: productId,
			rating: rating,
		};

		if (productId && userEmail) {
			addSingleReview({ data, userEmail });
			commentRef.current.value = '';
		} else {
			navigate('/account/login');
		}
	};
	{
		isSuccess && toast.success('Review Added Successfully');
	}
	return (
		<div>
			{showComment && (
				<div className="border-top border-bottom py-5">
					<div>
						<p className="fw-bold">What would you rate this product?</p>
						<div>
							{/* <MdStarBorder />
              <MdStarBorder />
              <MdStarBorder />
              <MdStarBorder />
              <MdStarBorder /> */}
							<ReactStars
								count={5}
								onChange={(newRating) => setRating(newRating)}
								size={24}
								activeColor="#ffd700"
								value={5}
							/>
						</div>
					</div>

					<form onSubmit={handleSubmit} className="mt-4">
						<Form.Group className="mb-3" controlId="formBasicEmail">
							<Form.Label className="fw-bold">
								Tell us your feedback about the product
							</Form.Label>
							<Form.Control
								type="text"
								as="textarea"
								rows={5}
								ref={commentRef}
								placeholder="Enter your comment"
								className="shadow-none rounded-0"
								required
							/>
						</Form.Group>
						{/* <Row>
              <Col lg={6} sm={12} xs={12}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label className="fw-bold">Your Name</Form.Label>
                  <Form.Control type="text" required placeholder="Enter name" />
                </Form.Group>
              </Col>
              <Col lg={6} sm={12} xs={12}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label className="fw-bold">Your Email</Form.Label>
                  <Form.Control
                    type="email"
                    required
                    placeholder="Enter email"
                  />
                </Form.Group>
              </Col>
            </Row> */}
						<div className="d-flex justify-content-end gap-2">
							<p
								variant="outline-dark"
								className="cancel-comment px-4 py-2"
								style={{ border: '1px solid black' }}
								type="button"
								onClick={() => setShowComment(false)}
							>
								Cancel
							</p>
							<UiButton variant="dark" type="submit" className="px-4 py-2">
								{isLoading ? 'Loading' : 'Submit'}
							</UiButton>
						</div>
					</form>
				</div>
			)}
			{!showComment && (
				<div className="d-flex align-items-center justify-content-between  pb-4 border-bottom">
					<div>
						<div className="d-flex align-items-center">
							<h1 className="my-0 p-0">4.70</h1>
							<div className="ms-2 d-flex align-items-center justify-content-start">
								<MdStar />
								<MdStar />
								<MdStar />
								<MdStarHalf />
								<MdStarOutline />
							</div>
						</div>
						<div>Based on 64 reviews</div>
					</div>
					<Button
						variant="dark"
						style={{ height: '2.75rem', borderRadius: '4px' }}
						className="shadow-none"
						onClick={() => setShowComment(true)}
					>
						Write Review
					</Button>
				</div>
			)}
		</div>
	);
};

export default WriteReview;
